<template>
  <!-- 站点信息 -->
  <div>
    <w-table
      v-if="typeName"
      v-loading.body="tableLoading"
      :data-list="companyData"
      :columns="staticData[typeName]"
      :bPagination="false"
    >
      <template slot-scope="props" slot="cell">
        <a
          v-if="
            props.column.label === '扫一扫巡查' ||
            props.column.label === '嗅探巡查'
          "
          @click="onShowDialog(props)"
          class="num"
          >{{ props.row[props.column.property] }}</a
        >
        <span v-else>{{ props.row[props.column.property] }}</span>
      </template>
    </w-table>
    <w-dialog
      ref="w-dialog"
      :title="dialogTitle"
      :width="width"
      :isShowFooter="false"
      className="i-dialog"
      @handleCloseRight="handleClose"
      @handleClose="handleClose"
    >
      <template v-slot:content>
        <w-table
          v-if="columnName"
          :data-list="bikeData"
          :columns="staticData[columnName]"
          :bPagination="false"
          :height="525"
        >
          <template slot-scope="props" slot="cell">
            <span v-if="props.column.label === '序号'">{{
              props.index + 1
            }}</span>
            <span v-else>{{ props.row[props.column.property] }}</span>
          </template>
        </w-table>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import WTable from "@/components/Table/index.vue";
import staticData from "./staticData.js";
import Api from "@/api";
import WDialog from "@/components/Model/index.vue";

export default {
  components: {
    WTable,
    WDialog,
  },
  props: ["typeName", "currentData"],
  data() {
    return {
      legality: null,
      brandIds: "",
      width: "50%",
      type: "",
      dialogTitle: "",
      tableLoading: false,
      tableData: null,
      companyData: [],
      bikeData: [],
      columnName: "",
    };
  },
  computed: {
    staticData() {
      return staticData;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    handleClose() {
      this.$refs["w-dialog"].onCloseDialog();
    },
    onShowDialog(data) {
      if (!data.row[data.column.property]) {
        return;
      }
      this.dialogTitle =
        data.row.brandName.slice(0, 2) + data.column.label + "未传数据车";
      this.columnName = data.column.property;
      this.bikeData =
        this.columnName == "mac_count" ? data.row.mac_list : data.row.list;
      this.width = this.columnName == "mac_count" ?'760px':"590px";
      // this.brandIds = data.row.brandId;
      // this.legality = data.column.label == "备案异常" ? 2 : 1;
      this.$refs["w-dialog"].onShowDialog();
    },
    initData() {
      const vm = this;
      vm.tableLoading = true;
      Api.getBikeNotUpload({ selfAreaId: vm.currentData.selfAreaId }).then(
        (res) => {
          if (res.code === 200) {
            vm.companyData = Object.values(res.data).map((val) => {
              return { ...val, ...val.count };
            });
          } else {
            vm.$message.warning(res.message);
          }
          vm.tableLoading = false;
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.num {
  color: #00dada;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
.export {
  margin-bottom: 16px;
  cursor: pointer;
}
</style>
